import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="container-page grid gap-10 py-12 md:grid-cols-2 md:py-16 lg:grid-cols-4">
        <div className="md:col-span-2 lg:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-emotion-laugh-fill text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-xl">歪歪漫画</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
            韩国歪歪漫画恶搞反转神展开脑洞魔性爆笑漫画合集，每日更新热门恶搞漫画，分类清晰，让你轻松找到想看的作品。
          </p>
          <div className="mt-5 flex gap-2">
            {['ri-weibo-line', 'ri-qq-line', 'ri-wechat-line', 'ri-bilibili-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                aria-label="社交媒体链接"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className={`${icon} text-sm`} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold tracking-wide text-background-50">热门分类</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {comicCategories.map((cat) => (
              <li key={cat.slug}>
                <Link to={`/category/${cat.slug}`} className="text-background-300 transition-colors hover:text-accent-300">
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold tracking-wide text-background-50">快速导航</h3>
          <ul className="mt-4 flex flex-col gap-2 text-sm">
            <li><Link to="/" className="text-background-300 transition-colors hover:text-accent-300">首页</Link></li>
            <li><Link to="/category/hot" className="text-background-300 transition-colors hover:text-accent-300">最新更新</Link></li>
            <li><Link to="/category/hilarious" className="text-background-300 transition-colors hover:text-accent-300">爆笑合集</Link></li>
            <li><Link to="/about" className="text-background-300 transition-colors hover:text-accent-300">关于我们</Link></li>
            <li><Link to="/contact" className="text-background-300 transition-colors hover:text-accent-300">联系我们</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold tracking-wide text-background-50">联系我们</h3>
          <ul className="mt-4 flex flex-col gap-2 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-300" aria-hidden="true" /> hello@waiwaicomic.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-300" aria-hidden="true" /> 每日 10:00 与 18:00 更新
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-chat-3-line text-accent-300" aria-hidden="true" /> 投稿合作：hi@waiwaicomic.com
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-foreground-800">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-400 sm:flex-row">
          <p>© 2026 歪歪漫画 WaiWai Comic · 本站内容仅供娱乐阅读，请理性追更</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-400" aria-hidden="true" />
            歪歪一下，笑口常开
          </p>
        </div>
      </div>
    </footer>
  );
}